import {h} from 'preact';
import LinksToSocialNetworks from "../../components/LinksToSocialNetworks/LinksToSocialNetworks";
import CasesGrid from "../../components/CasesGrid/CasesGrid";
import FeedbackSlider from "../../components/FeedbackSlider/FeedbackSlider";
import styles from "./style.scss"
import ReturnBack from "./ReturnBack";
import PaidServicesDocuments from "./PaidServicesDocuments";

const Success = () => {
  return (
      <main id="main-container" className={styles.wrapper} main-attr>
          <ReturnBack></ReturnBack>

          <h1>Платные образовательные услуги</h1>
          <h2>Документы</h2>
          <PaidServicesDocuments/>

          <h2>Стоимость услуг</h2>
          <ul className={'pdfLinks'}>
              <li>
                  <a target="_blank"
                     href={'/assets/documents/stoimost/prikaz-stoimost-licenzii-2025-08-18.pdf'}>
                      Приказ о стоимости лицензии от 18.08.2025
                  </a>
              </li>
              <li>
                  <a target="_blank"
                     href={'/assets/documents/stoimost/prikaz-stoimost-obucheniya-2025-08-18.pdf'}>
                      Приказ о стоимости обучения от 18.08.2025
                  </a>
              </li>
              <li>
                  <a target="_blank"
                     href={'/assets/documents/stoimost/prikaz-stoimost-trudoustroystva-2025-08-18.pdf'}>
                      Приказ о стоимости трудоустройства от 18.08.2025
                  </a>
              </li>
              <li>
                  <a target="_blank"
                     href={'/assets/documents/stoimost/prikaz-stoimost-licenzii-2026-04-01.pdf'}>
                      Приказ о стоимости лицензии от 01.04.2026
                  </a>
              </li>
              <li>
                  <a target="_blank"
                     href={'/assets/documents/stoimost/prikaz-stoimost-obucheniya-2026-04-01.pdf'}>
                      Приказ о стоимости обучения от 01.04.2026
                  </a>
              </li>
              <li>
                  <a target="_blank"
                     href={'/assets/documents/stoimost/prikaz-stoimost-trudoustroystva-2026-04-01.pdf'}>
                      Приказ о стоимости трудоустройства от 01.04.2026
                  </a>
              </li>
              <li>
                  <a target="_blank"
                     href={'/assets/documents/stoimost/prikaz-stoimost-licenzii-2026-05-06.pdf'}>
                      Приказ о стоимости лицензии от 06.05.2026
                  </a>
              </li>
              <li>
                  <a target="_blank"
                     href={'/assets/documents/stoimost/prikaz-stoimost-licenzii-2026-07-01.pdf'}>
                      Приказ о стоимости лицензии от 01.07.2026
                  </a>
              </li>
              <li>
                  <a target="_blank"
                     href={'/assets/documents/stoimost/prikaz-stoimost-obucheniya-2026-07-01.pdf'}>
                      Приказ о стоимости обучения от 01.07.2026
                  </a>
              </li>
              <li>
                  <a target="_blank"
                     href={'/assets/documents/stoimost/prikaz-stoimost-trudoustroystva-2026-07-01.pdf'}>
                      Приказ о стоимости трудоустройства от 01.07.2026
                  </a>
              </li>

              {/*<li>*/}
              {/*    <a target="_blank" href={'/assets/documents/platnie/2_prikaz-o-stoimosti.pdf'}>Приказ об утверждении*/}
              {/*        стоимости обучения*/}
              {/*    </a>*/}
              {/*</li>*/}
              {/*<li>*/}
              {/*    <a target="_blank" href={'/assets/documents/4_prikaz-o-stoimosti-24.pdf'}>Приказ об утверждении*/}
              {/*        стоимости обучения на 2024 год*/}
              {/*    </a>*/}
              {/*</li>*/}
              {/*<li>*/}
              {/*    <a target="_blank" href={'/assets/documents/dogovor.pdf'}>Договор на обучение ООО ИТК*/}
              {/*    </a>*/}
              {/*</li>*/}
          </ul>
      </main>
  );
};

export default Success;
